<template functional>
  <div
    :class="[$style.root, data.class, data.staticClass]"
    :style="[data.style, data.staticStyle]"
  >
    <slot></slot>
    <span :class="$style.value">{{ props.value.toLocaleString() }}</span>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="scss" module>
.root {
  font-size: 1.125rem;
  font-weight: bold;
  color: #3c495d;
}

.value {
  color: #35ccff;
  margin-left: 0.5rem;
}
</style>
